import {
  Avatar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Skeleton } from "@material-ui/lab";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import {
  BsArrowUpRightSquare,
  BsCalendarPlus,
  BsLink45Deg,
} from "react-icons/bs";
import {
  FaCalendarAlt,
  FaCopy,
  FaRegClock,
  FaTimesCircle,
} from "react-icons/fa";
import { RiReservedLine } from "react-icons/ri";
import ReactPlayer from "react-player";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import CalenderService from "../../api/CalenderService.js";
import MyYuukke from "../../api/MyYuukke.js";
import ProfileService from "../../api/ProfileService.js";
import { JITSI_URL } from "../../config/app-config.js";
import OtpInput from "../Login/LoginV2/OtpInput.jsx";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: "1280px",
    margin: "1rem auto",
    padding: "0.4rem",
    fontFamily: "'Inter', sans-serif",
    [theme.breakpoints.down("sm")]: {
      padding: "0 1rem",
    },
    width: "100%",
  },
  heroSection: {
    position: "relative",
    borderRadius: 24,
    overflow: "hidden",
    marginBottom: theme.spacing(3),
    boxShadow: theme.shadows[4],
    height: 290,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
  },
  playerWrapper: {
    width: "100%",
    height: "100%",
    position: "relative",
  },
  reactPlayer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    "& video": {
      objectFit: "cover",
    },
  },
  heroContent: {
    position: "relative",
    zIndex: 2,
    padding: "4rem",
    color: "white",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "2rem",
    },
  },
  eventTitle: {
    fontSize: "1.24rem",
    fontWeight: 500,
    // marginBottom: "2px",
    // marginLeft: "32px",
    // marginTop: "20px",
    marginInlineStart: "45px",
    marginTop: "10px",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.2rem",
    },
  },
  contentGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 350px",
    gap: "2rem",
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "1fr",
    },
  },
  detailsCard: {
    background: theme.palette.background.paper,
    borderRadius: "24px",
    padding: "2rem",
    boxShadow: theme.shadows[2],
    [theme.breakpoints.down("sm")]: {
      padding: "1rem",
    },
    maxWidth: "100%",
    minWidth: "100% !important",
  },

  actionCard: {
    background: theme.palette.background.paper,
    borderRadius: "24px",
    padding: "2rem",
    boxShadow: theme.shadows[2],
    position: "sticky",
    top: "2rem",
    border: `1px solid ${theme.palette.divider}`,
  },
  dateTimeBadge: {
    display: "inline-flex",
    alignItems: "center",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1, 2),
    marginLeft: "45px",
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
    "& svg": {
      // marginRight: theme.spacing(1),
      // color: theme.palette.secondary.main,
      display: "none",
    },
    "& .MuiTypography-root": {
      margin: 0,
    },
    "& .MuiTypography-subtitle1": {
      fontWeight: 500,
      marginRight: theme.spacing(2),
    },
    "& .MuiTypography-body1": {
      color: theme.palette.text.secondary,
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  sectionTitle: {
    fontSize: "1.5rem",
    fontWeight: 700,
    marginBottom: "0rem",
    color: theme.palette.text.primary,
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    "& svg": {
      color: theme.palette.primary.main,
    },
  },
  meetingLink: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    padding: "1.5rem",
    borderRadius: "16px",
    background: theme.palette.background.default,
    border: `1px solid ${theme.palette.divider}`,
    margin: "1rem 0",
    transition: "all 0.2s ease",
    "&:hover": {
      background: theme.palette.action.hover,
    },
  },
  actionButton: {
    width: "100%",
    padding: "1.25rem",
    borderRadius: "12px",
    fontWeight: 600,
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    marginBottom: "1rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "1rem",
    fontSize: "1rem",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: theme.shadows[2],
    },
  },
  primaryButton: {
    background: theme.palette.primary.main,
    color: "white",
    "&:hover": {
      background: theme.palette.primary.dark,
    },
  },
  secondaryButton: {
    background: "none",
    color: theme.palette.text.primary,
    border: `2px solid ${theme.palette.divider}`,
    "&:hover": {
      background: theme.palette.action.hover,
    },
  },
  calendarGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
    gap: "1rem",
    margin: "2rem 0",
  },
  dateCard: {
    padding: "0.4rem 0.1rem",
    borderRadius: "16px",
    textAlign: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
    border: `2px solid ${theme.palette.divider}`,
    "&.selected": {
      // borderColor: theme.palette.primary.main,
      background: "#b8d9ff",
      color: "#575757",
    },
    "&.disabled": {
      opacity: 0.5,
      cursor: "not-allowed",
      background: theme.palette.action.disabledBackground,
    },
  },
  timeSlot: {
    padding: "1rem 1.5rem",
    borderRadius: "12px",
    background: "#fff",
    border: `1px solid ${theme.palette.divider}`,
    cursor: "pointer",
    transition: "all 0.2s ease",
    margin: "0.5rem",
    display: "inline-flex",
    alignItems: "center",
    gap: "0.5rem",
    fontSize: "0.9rem",
    "&.selected": {
      background: "#007bff",
      color: "white",
      // borderColor: theme.palette.primary.main,
      boxShadow: theme.shadows[2],
    },
    "&.disabled": {
      position: "relative",
      overflow: "hidden",
      opacity: 0.5,
      cursor: "not-allowed",
      "&:after": {
        content: '""',
        position: "absolute",
        left: 0,
        top: "50%",
        width: "100%",
        height: "2px",
        background: theme.palette.error.main,
        transform: "rotate(-45deg)",
      },
    },
  },
  dialogActions: {
    padding: "16px 24px",
    gap: "1rem",
  },
  dialogButton: {
    padding: "10px 24px",
    backgroundColor: "#007bff",
    borderRadius: "8px",
    fontWeight: 600,
    transition: "all 0.2s ease",
  },
}));

const EventPage = () => {
  const authenticated = useSelector(
    (state) => state.loginDetailsApi.keycloakAuthenticated
  );
  const classes = useStyles();
  const theme = useTheme();

  let currentDate = moment(new Date()).format("yyyy-MM-DD");
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const [state, setState] = useState({
    loading: true,
    data: "",
    error: "",
    title: "",
    description: "",
    startDate: "",
    endDate: "",
    exStartDate: "",
    type: "",
    exEndDate: "",
    meeting: "",
    slotBookingId: "",
    cancelStatus: false,
    optScreen: false,
    otp: "",
    otpId: "",
    monthDates: [],
    availableSlot: [],
    activeIndexData: null,
    selectedSlot: null,
    dayId: null,
  });

  const slug =
    location.pathname.slice(location.pathname.lastIndexOf("/") + 1) ?? "";
  console.log("slug", slug);
  useEffect(() => {
    let page = document.querySelector(".nav-menu-new");
    if (page && !authenticated) {
      page.classList.remove("nav-menu-new");
    }
  }, []);

  useEffect(() => {
    moment.locale("en");
  }, []);

  useEffect(() => {
    if (slug) {
      CalenderService.getEventDetails(slug)
        .then((response) => {
          let result = response.data.data;
          console.log("event details", response);
          if (result?.taskName) {
            setState({
              ...state,
              loading: false,
              title: result.taskName,
              description: result.taskDescription,
              meetingLink: result.url,
              startDate: result.startDate,
              endDate: result.endDate,
              meeting: result,
              slotBookingId: result.slotBookingId,
              exStartDate: moment(result.startDate).format("yyyy-MM-DD"),
            });
          } else {
            setState({
              ...state,
              loading: false,
              error: result,
            });
          }
        })
        .catch((e) => {
          console.log("e", e);
        });

      CalenderService.getTimeSlotDetails(slug)
        .then((response) => {
          let result = response.data.data;
          console.log("SLot_details", result);

          const data = response.data.data;
          const {
            service = [],
            slots = [],
            bookedSlot = [],
            userDetails,
            eventData,
          } = data;

          // Generate the array of 30 days and mark which have available slots
          const dayList = slots.reduce((acc, slot) => {
            if (slot.timeSlots?.length > 0) acc.push(slot.day); // e.g. "MON", "TUE"
            return acc;
          }, []);
          const monthDates = generateMonthDates(dayList);
          // Find the first date that’s “available”
          const indexOfDate = monthDates.findIndex(
            (item) => item.available === true
          );
          let activeIndexData =
            indexOfDate >= 0 ? monthDates[indexOfDate] : null;

          // If we have an available date, pick its slots
          let findSlots = null;
          if (activeIndexData) {
            findSlots = slots.find(
              (item) => item.day === activeIndexData.day.toUpperCase()
            );
          }
          // Put data in state
          setState((prev) => ({
            ...prev,
            serviceList: service,
            userSlots: slots,
            bookedSlot: bookedSlot,
            userDetails: userDetails,
            eventDetails: eventData,
            monthDates: monthDates,
            activeIndexData: activeIndexData,
            loader: false,
            dayId: findSlots?.id || null,
          }));

          // If we have a valid “first date,” load its available time slots
          if (activeIndexData && findSlots) {
            viewAvailableSlot(activeIndexData.index, activeIndexData, true);
          }
        })
        .catch((e) => {
          console.log("getTimeSlotDetails >>e", e);
        });
    }
  }, []);

  /*************************************************
   * 2.  GENERATE MONTH DATES (like reference)
   *************************************************/
  const generateMonthDates = (availableDays) => {
    const today = new Date();
    const daysArray = [];
    for (let i = 0; i < 30; i++) {
      const date = new Date();
      date.setDate(today.getDate() + i);

      const dayName = date
        .toLocaleDateString("en-US", { weekday: "short" })
        .toUpperCase();
      daysArray.push({
        date: date.getDate(),
        day: dayName, // e.g. "MON", "TUE"
        value: moment(date).format("YYYY/MM/DD"), // e.g. "2025/04/02"
        available: availableDays.includes(dayName),
        index: i,
      });
    }
    return daysArray;
  };

  /*************************************************
   * 3.  GET AVAILABLE TIME SLOTS FOR A DATE
   *************************************************/
  const getAvailableDateSlot = (date, availableSlot, bookedSlot) => {
    // If no bookedSlot, everything is open
    if (!bookedSlot || bookedSlot.length === 0) {
      return availableSlot.map((item) => ({ ...item, slotAvailable: true }));
    }

    // If the date is “today,” filter out past times
    const convertToDate = (timeStr) => {
      const [hours, minutes] = timeStr.split(":").map(Number);
      const d = new Date();
      d.setHours(hours, minutes, 0, 0);
      return d;
    };
    let filterCurrentDateSlots = availableSlot;
    if (date === moment(new Date()).format("YYYY/MM/DD")) {
      filterCurrentDateSlots = availableSlot.filter(
        (slot) => convertToDate(slot.from) >= new Date()
      );
    }

    // For the chosen date, find the already-booked times
    const findDateBasedSlot = bookedSlot
      .filter((item) => date === moment(item.startTime).format("YYYY/MM/DD"))
      .map((item) => {
        let ts = JSON.parse(item.timeSlot);
        return ts[0].from; // e.g. "13:15"
      });

    // Mark each slot as available or not
    const filteredList = filterCurrentDateSlots.map((slot) => {
      return {
        ...slot,
        slotAvailable: !findDateBasedSlot.includes(slot.from),
      };
    });
    return filteredList;
  };

  /*************************************************
   * 4.  WHEN USER SELECTS A DATE
   *************************************************/
  const viewAvailableSlot = (index, dateObj, isAvailable) => {
    if (!isAvailable) return;

    const findSlots = state.userSlots.find(
      (item) => item.day === dateObj.day.toUpperCase()
    );
    if (!findSlots) return;

    const bookedSlotCopy = [...state.bookedSlot];
    const list = getAvailableDateSlot(
      dateObj.value,
      findSlots.timeSlots,
      bookedSlotCopy
    );

    updateState("availableSlot", list);
    updateState("activeIndexData", { ...dateObj, index });
    updateState("selectedSlot", null);
    updateState("dayId", findSlots.id);
  };

  const handleSlotSelect = (slot) => {
    if (!slot.slotAvailable) {
      toast.info("This slot is already booked. Please pick another slot.");
      return;
    }
    updateState("selectedSlot", slot);
  };

  const handleAddToGoogleCalendar = () => {
    const googleCalendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
      state.title
    )}&dates=${encodeURIComponent(
      moment(state.startDate)
        .toISOString()
        .replace(/-|:|\.\d\d\d/g, "")
    )}/${encodeURIComponent(
      moment(state.endDate)
        .toISOString()
        .replace(/-|:|\.\d\d\d/g, "")
    )}&details=${encodeURIComponent(
      state.description
    )}&location=${encodeURIComponent()}`;
    window.open(googleCalendarUrl, "_blank");
  };

  const handleAddToAppleCalendar = () => {
    const appleCalendarUrl = `data:text/calendar;charset=utf8,BEGIN:VCALENDAR\nVERSION:2.0\nBEGIN:VEVENT\nDTSTART:${moment(
      state.startDate
    ).toISOString()}\nDTEND:${moment(state.endDate).toISOString()}\nSUMMARY:${
      state.title
    }\nDESCRIPTION:${
      state.description
    }\nLOCATION:${location}\nEND:VEVENT\nEND:VCALENDAR`;
    const blob = new Blob([appleCalendarUrl], {
      type: "text/calendar;charset=utf-8",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "event.ics");
    document.body.appendChild(link);
    link.click();
  };
  const handleAddToOutlookCalendar = () => {
    const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
DTSTART:${moment(state.startDate).toISOString()}
DTEND:${moment(state.endDate).toISOString()}
SUMMARY:${state.title}
DESCRIPTION:${state.description}
 END:VEVENT
END:VCALENDAR`;

    const blob = new Blob([icsContent], {
      type: "text/calendar;charset=utf-8",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "event.ics");
    document.body.appendChild(link);
    link.click();
  };
  const addToMyCalendar = (e) => {
    if (e === "Google") {
      handleAddToGoogleCalendar();
    } else if (e === "Apple") {
      handleAddToAppleCalendar();
    } else {
      handleAddToOutlookCalendar();
    }
  };

  const updateState = (name, value) => {
    setState((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleReschedule = () => {
    if (!state.selectedSlot || !state.activeIndexData) {
      toast.error("Please select a time slot first");
      return;
    }

    // Create moment objects from selected date and time
    const selectedDate = moment(state.activeIndexData.value, "YYYY/MM/DD");
    const startTime = moment(state.selectedSlot.from, "HH:mm");

    // Combine date and time
    const startDateTime = selectedDate
      .set({
        hour: startTime.get("hour"),
        minute: startTime.get("minute"),
      })
      .toISOString();

    const endDateTime = moment(startDateTime).add(15, "minutes").toISOString();

    const payload = {
      bookingId: state.slotBookingId,
      startTime: startDateTime,
      endTime: endDateTime,
    };

    MyYuukke.rescheduleMeeting(payload)
      .then(() => {
        toast.success("Meeting rescheduled successfully!");
        setOpen(false);
        // You might want to refresh event data here
      })
      .catch((error) => {
        console.error("Reschedule error:", error);
        toast.error("Failed to reschedule meeting");
      });
  };

  const cancelMeeting = () => {
    console.log("Cancel Meeting" + state.slotBookingId);
    if (!state.type) {
      toast.error("User type is not set. Please try again.");
      return;
    }
    console.log("Cancel Meeting - User Type:", state.type);
    Swal.fire({
      icon: "warning",
      title: "Service Cancellation Confirmation",
      text: "Are you sure you want to cancel the meeting?",
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: "Yes, Sure",
      cancelButtonText: "No",
    })
      .then((res) => {
        if (res.isConfirmed) {
          updateState("loader", true);
          let payload = {
            bookingId: state.slotBookingId,
            type: state.type,
          };
          MyYuukke.cancelSlotBooking(payload)
            .then((res) => {
              // userUpcomingMeting(data.bookingId);
              Swal.fire({
                icon: "success",
                title: "Meeting Cancelled successfully",
                showConfirmButton: true,
              }).then((result) => {
                updateState("loader", false);
                updateState("cancelStatus", true);
              });
            })
            .catch((e) => {
              toast.error("Something went wrong , try later");
              updateState("loader", false);
              updateState("cancelStatus", false);
            });
        }
      })
      .catch((e) => {
        console.log("Error " + e);
      });
  };

  const joinMeeting = () => {
    let regex = state.meeting.url.replace(/&.*/, "");

    if (state.meeting.taskType === "mentor") {
      window.open(`${JITSI_URL}/${regex}?&sp=yes`, "_blank");
    } else if (!state.meeting.meetingInApplication) {
      window.open(state.meeting.url, "_blank");
    } else if (state.meeting.taskType === "public") {
      window.open(`${JITSI_URL}/${regex}?&isGlob=true&sp=yes#config`, "_blank");
    } else {
      window.open(
        `${JITSI_URL}/${regex}?&isGroup=true&sp=yes#config`,
        "_blank"
      );
    }
  };
  const showLink = () => {
    if (state?.meeting?.url) {
      let regex = state.meeting.url.replace(/&.*/, "");
      if (state.meeting.taskType === "mentor") {
        return `${JITSI_URL}/${regex}?&sp=yes#config`;
      } else if (!state.meeting.meetingInApplication) {
        return state.meeting.url;
      } else if (state.meeting.taskType === "public") {
        return `${JITSI_URL}/${regex}?&isGlob=true&sp=yes#config`;
      } else {
        return `${JITSI_URL}/${regex}?&isGroup=true&sp=yes#config`;
      }
    }
  };
  const handleCopy = async () => {
    let regex = state.meeting.url.replace(/&.*/, "");
    if (!state.meeting.meetingInApplication) {
      await navigator.clipboard.writeText(state.meeting.url);
    } else if (state.meeting.taskType === "mentor") {
      await navigator.clipboard.writeText(
        `${JITSI_URL}/${regex}?&sp=yes#config`
      );
    } else if (state.meeting.taskType === "public") {
      await navigator.clipboard.writeText(
        `${JITSI_URL}/${state.meeting.url}?&isGlob=true&sp=yes#config`
      );
    } else {
      await navigator.clipboard.writeText(
        `${JITSI_URL}/${regex}?&isGroup=true&sp=yes#config`
      );
    }
    toast.success("Link coped in you clip board");
  };
  const verifyOtp = () => {
    updateState("loader", true);

    let number = {
      otp: state.otp,
      id: state.otpId,
    };
    ProfileService.validateUserOtp(number)
      .then((response) => {
        if (response.data.data === "VALID_OTP") {
          // updatePhoneNumber();
          cancelMeeting();
          handleClose();
        } else {
          toast.error("Wrong otp");
          updateState("loader", false);
        }
      })
      .catch((e) => {
        console.log("e", e);
        toast.error("Something went wrong");
        updateState("loader", false);
      });
  };
  const sendMobileOtp = (type) => {
    setState((prev) => ({
      ...prev,
      type: type,
    }));
    console.log(" User type", state.type);
    let data = {
      type: type,
      slug: slug,
      bookingId: state.slotBookingId,
    };

    ProfileService.sendServiceOtp(data)
      .then((response) => {
        if (response.data.data?.id) {
          // Corrected: Use functional update to merge with latest state
          setState((prev) => ({
            ...prev,
            otpId: response.data.data.id,
            loader: false,
            optScreen: true,
          }));
        }
      })
      .catch((e) => {
        console.log("e", e);
        toast.error("Something went wrong");
        updateState("loader", false);
      });
  };
  const handleClose = () => {
    setState((previous) => ({
      ...previous,
      otpId: null,
      loader: false,
      optScreen: false,
      cancelMeetingModel: false,
    }));
  };

  useEffect(() => {
    console.log("User type changed:", state.type);
  }, [state.type]);

  const meetingCopy = useMemo(showLink, [state]);
  console.log("state", state);
  return (
    <div className={classes.container}>
      <div className={classes.heroSection}>
        <div className={classes.playerWrapper}>
          <ReactPlayer
            key={state.slotBookingId !== null ? "video1" : "video2"} // key added here
            className={classes.reactPlayer}
            url={
              state.slotBookingId !== null
                ? "https://corporate.yuukke.com/bcav2/auth/video/e1f8139d-cb40-41e6-9eed-ba3ac7c5b495"
                : "https://corporate.yuukke.com/bcav2/auth/video/d44f1c53-8ade-4be4-8383-e2bd39b42b8c"
            }
            playing
            loop
            muted
            width="100%"
            height="100%"
            config={{
              file: { attributes: { playsInline: true } },
            }}
          />
        </div>
      </div>

      <div className={classes.contentGrid}>
        <div className={classes.detailsCard}>
          <Box>
            {/* Section Header */}
            <div className={classes.sectionTitle}>
              <BsLink45Deg size={28} />
              <span>Event Details</span>
            </div>

            {/* Title or Loader */}
            <Typography variant="h4" className={classes.eventTitle}>
              {state.title ? (
                state.title
              ) : (
                <Skeleton variant="rect" width="100%" height={56} />
              )}
            </Typography>

            {/* Date / Time Badge */}
            {!state.cancelStatus && state.startDate && state.endDate && (
              <Box className={classes.dateTimeBadge}>
                <FaRegClock size={20} />
                <Typography variant="subtitle1">
                  {moment(state.startDate).format("dddd, MMMM Do YYYY")}
                </Typography>

                <Typography variant="body1">
                  {moment(state.startDate).format("h:mm A")} –{" "}
                  {moment(state.endDate).format("h:mm A")}
                </Typography>
              </Box>
            )}
          </Box>

          <div className={classes.sectionTitle} style={{ marginTop: "2.7rem" }}>
            <FaCopy size={24} />
            <span>Meeting Link</span>
          </div>

          <div className={classes.meetingLink}>
            {meetingCopy ? (
              <>
                <Typography noWrap style={{ flex: 1 }}>
                  {meetingCopy}
                </Typography>
                <IconButton
                  onClick={handleCopy}
                  color="primary"
                  style={{ background: "rgba(25, 118, 210, 0.1)" }}
                >
                  <FaCopy size={20} />
                </IconButton>
              </>
            ) : (
              <Skeleton variant="rect" width="100%" height={56} />
            )}
          </div>
        </div>

        <div className={classes.actionCard}>
          {state.loading ? (
            [...Array(3)].map((_, i) => (
              <Skeleton
                key={i}
                variant="rect"
                height={56}
                className={classes.skeleton}
              />
            ))
          ) : state.title ? (
            <>
              {state.cancelStatus ? (
                <Chip
                  label="Meeting Cancelled"
                  color="secondary"
                  variant="outlined"
                  style={{ width: "100%", padding: "1rem" }}
                />
              ) : (
                <>
                  {moment(state.exStartDate).isBefore(currentDate) ||
                  moment(state.exStartDate).isSame(currentDate) ? (
                    <Button
                      variant="contained"
                      size="large"
                      className={`${classes.actionButton} ${classes.primaryButton}`}
                      onClick={joinMeeting}
                      startIcon={<BsArrowUpRightSquare />}
                    >
                      Join Meeting Now
                    </Button>
                  ) : (
                    <>
                      <Chip
                        label="Meeting Not Started"
                        color="default"
                        variant="outlined"
                        style={{ width: "100%", padding: "1rem" }}
                        icon={<RiReservedLine />}
                      />

                      {state.slotBookingId !== null && (
                        <Box
                          mt={3}
                          display="flex"
                          flexDirection="column"
                          gap={2}
                        >
                          <Button
                            variant="outlined"
                            className={`${classes.actionButton} ${classes.secondaryButton}`}
                            onClick={() =>
                              updateState("cancelMeetingModel", true)
                            }
                            startIcon={
                              <FaTimesCircle
                                style={{ color: "#dc3545", fontSize: 20 }}
                              />
                            }
                          >
                            Cancel Meeting
                          </Button>

                          <Button
                            variant="contained"
                            className={`${classes.actionButton} ${classes.primaryButton}`}
                            onClick={() => setOpen(true)}
                            startIcon={<FaCalendarAlt />}
                          >
                            Reschedule Meeting
                          </Button>
                        </Box>
                      )}
                    </>
                  )}
                </>
              )}

              <Divider style={{ margin: "2rem 0" }} />

              <div className={classes.sectionTitle}>
                <BsCalendarPlus size={24} />
                <span>Add to Calendar</span>
              </div>

              <TextField
                fullWidth
                select
                variant="outlined"
                label="Add to Calendar"
                onChange={(e) => addToMyCalendar(e.target.value)}
                style={{
                  marginTop: "24px",
                  borderRadius: "12px",
                  backgroundColor: theme.palette.background.default,
                }}
                InputProps={{
                  style: {
                    borderRadius: "12px",
                    backgroundColor: theme.palette.background.default,
                  },
                }}
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      style: {
                        borderRadius: "12px",
                        marginTop: "8px",
                        boxShadow: theme.shadows[3],
                      },
                    },
                  },
                }}
              >
                {/* Google Calendar Option */}
                <MenuItem value="Google">
                  <Box display="flex" alignItems="center" gap={2} py={1}>
                    <Avatar
                      src="/google-calendar.png"
                      style={{ width: 32, height: 32 }}
                    />
                    <Typography variant="body1">Google Calendar</Typography>
                  </Box>
                </MenuItem>

                {/* Apple Calendar Option with ICS Download */}
                <MenuItem value="Apple">
                  <Box display="flex" alignItems="center" gap={2} py={1}>
                    <Avatar
                      src="/apple-calendar.png"
                      style={{ width: 32, height: 32 }}
                    />
                    <Box>
                      <Typography variant="body1">Apple Calendar</Typography>
                      <Typography variant="caption" color="textSecondary">
                        Download ICS file
                      </Typography>
                    </Box>
                  </Box>
                </MenuItem>

                {/* Outlook Calendar Option */}
                <MenuItem value="Outlook">
                  <Box display="flex" alignItems="center" gap={2} py={1}>
                    <Avatar
                      src="/outlook-calendar.png"
                      style={{ width: 32, height: 32 }}
                    />
                    <Typography variant="body1">Outlook Calendar</Typography>
                  </Box>
                </MenuItem>
              </TextField>
            </>
          ) : (
            <Box textAlign="center" py={4}>
              <Typography variant="h6" color="error" gutterBottom>
                {state.error === "EVENT_EXPIRED"
                  ? "This event has already concluded"
                  : state.error === "EVENT_DELETED"
                  ? "This event has been cancelled"
                  : "Error loading event details"}
              </Typography>
              <Button
                variant="contained"
                href="https://yuukke.com/"
                // className="refer-phone-btn"
                style={{
                  padding: "0.5rem 1.5rem",
                  backgroundColor: "rgb(255 255 255)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Return to Home
              </Button>
            </Box>
          )}
        </div>
      </div>

      {/* Cancel Meeting Dialog */}
      <Dialog
        open={state.cancelMeetingModel}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: "24px",
            padding: "1rem",
          },
        }}
      >
        <DialogTitle>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={5}
            width="100%"
          >
            <FaTimesCircle
              style={{ color: "#dc3545", fontSize: 24, marginRight: 8 }}
            />
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              Cancel Meeting
            </Typography>
          </Box>
        </DialogTitle>

        <Modal.Body>
          <div className="d-flex align-items-center justify-content-center flex-column block-theme-service">
            {state.optScreen ? (
              <>
                <p className="mt-2 mb-3">
                  Enter the 6‑digit OTP sent to your mobile number
                </p>

                <div className="d-flex g-1">
                  <OtpInput
                    length={6}
                    onOtpSubmit={(otp) => updateState("otp", otp)}
                  />
                </div>

                <div
                  className="d-flex justify-content-center gap-3 mt-4"
                  style={{ gap: "2rem" }}
                >
                  <button
                    onClick={verifyOtp}
                    type="submit"
                    className="refer-phone-btn"
                    style={{
                      padding: "0.5rem 1.5rem",
                      backgroundColor: "#007bff",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    Verify
                  </button>

                  <button
                    onClick={handleClose}
                    className="refer-phone-btn"
                    style={{
                      padding: "0.5rem 1.5rem",
                      backgroundColor: "#007bff",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </>
            ) : (
              <>
                <Typography variant="body1" gutterBottom>
                  Please verify your identity to cancel the meeting
                </Typography>
                <Box mt={4} display="flex" gap={2} flexDirection="column">
                  <Button
                    fullWidth
                    variant="outlined"
                    className={`${classes.actionButton} ${classes.secondaryButton}`}
                    onClick={() => sendMobileOtp("provider")}
                    startIcon={<FaCalendarAlt />}
                  >
                    Verify as Service Provider
                  </Button>
                  <Button
                    fullWidth
                    variant="outlined"
                    className={`${classes.actionButton} ${classes.secondaryButton}`}
                    onClick={() => sendMobileOtp("user")}
                    startIcon={<RiReservedLine />}
                  >
                    Verify as Client
                  </Button>
                </Box>
              </>
            )}
          </div>
        </Modal.Body>
      </Dialog>

      {/* Enhanced Reschedule Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{
          style: {
            borderRadius: "24px",
            padding: "2rem",
          },
        }}
      >
        <DialogTitle>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={5}
            width="100%"
          >
            <FaCalendarAlt
              style={{ color: theme.palette.primary.main, marginRight: 8 }}
              size={21}
            />
            <Typography variant="h6" fontWeight="bold">
              Reschedule Meeting
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Box my={3}>
            <Typography variant="subtitle1" gutterBottom fontWeight="500">
              Select a new date and time
            </Typography>

            <div className={classes.calendarGrid}>
              {state.monthDates.map((dateObj, i) => (
                <div
                  key={i}
                  className={`${classes.dateCard} 
                    ${dateObj.available ? "" : "disabled"}
                    ${state.activeIndexData?.index === i ? "selected" : ""}
                  `}
                  onClick={() =>
                    viewAvailableSlot(i, dateObj, dateObj.available)
                  }
                >
                  <Typography variant="caption" color="textSecondary">
                    {dateObj.day}
                  </Typography>
                  <Typography variant="h6" fontWeight={500}>
                    {dateObj.date}
                  </Typography>
                </div>
              ))}
            </div>

            {state.availableSlot?.length > 0 && (
              <>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  fontWeight="500"
                  mt={4}
                >
                  Available Time Slots
                </Typography>
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {state.availableSlot.map((slot, idx) => (
                    <div
                      key={idx}
                      className={`${classes.timeSlot} 
                        ${slot.slotAvailable ? "" : "disabled"}
                        ${
                          state.selectedSlot?.from === slot.from
                            ? "selected"
                            : ""
                        }
                      `}
                      onClick={() => handleSlotSelect(slot)}
                    >
                      <FaRegClock />
                      {moment(slot.from, "HH:mm").format("h:mm A")} -{" "}
                      {moment(slot.to, "HH:mm").format("h:mm A")}
                    </div>
                  ))}
                </Box>
              </>
            )}
          </Box>
        </DialogContent>

        <DialogActions className={classes.dialogActions}>
          <Button
            onClick={() => setOpen(false)}
            className="refer-phone-btn"
            style={{
              padding: "0.5rem 1.5rem",
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className={`${classes.dialogButton} ${classes.primaryButton}`}
            onClick={handleReschedule}
            disabled={!state.selectedSlot}
          >
            Confirm New Time
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default EventPage;
